
import moment from 'moment';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';

export class WeekPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Week;
    hasNavigation = true;
    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        let endDate: Date;
        const currentDate = moment().startOf('day').toDate();
        endDate = currentDate;
        const firstDayOfTheWeek = moment(endDate).startOf('isoWeek').toDate();
        const startDate = moment(firstDayOfTheWeek).startOf('day').toDate();
        endDate = moment(endDate).endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = startDate;
        periodFilter.endDate = endDate;

        periodFilter.periodInterval = NewPeriodSelectorInterval.Week;

        return periodFilter;
    }

    getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        let newStartDate;
        let newEndDate = moment(currentFilter.startDate)
            .add(-1, 'day')
            .toDate();
        newStartDate = moment(newEndDate)
            .add(-6, 'day')
            .startOf('day')
            .toDate();
        newEndDate = moment(newEndDate).endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Week;

        return periodFilter;
    }

    getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        const newStartDate = moment(currentFilter.endDate).add(1, 'day').startOf('day').toDate();
        let newEndDate = moment(newStartDate).add(6, 'day').endOf('day').toDate();

        if (moment(newEndDate).endOf('day') > moment().endOf('day')) {
            newEndDate = moment().endOf('day').toDate();
        }

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Week;

        return periodFilter;
    }
}
